import { ref } from 'vue';

export function useFetchMoreData(data, chunkSize, fetchData, tag) {
  const offset = ref(0);
  const limit = ref(chunkSize);
  const loading = ref(false);

  const append = (moreDataChunk) => {
    data.value.push(...moreDataChunk);
  };

  async function fetchMoreData() {
    if (loading.value) {
      return;
    }

    loading.value = true;
    offset.value += chunkSize;
    limit.value += chunkSize;

    const moreDataChunk = await fetchData({
      tag: tag ? tag.value : null,
      offset: offset.value,
      limit: limit.value,
    });

    append(moreDataChunk);
    loading.value = false;
  }

  return { fetchMoreData, loading };
}
